import { KNOW_BEFORE, LOCATION } from "../data/content";
import { PageIntro } from "../components/PageIntro";
import { Reveal } from "../components/Reveal";
import { ArrowUpRight } from "lucide-react";

export default function Visit() {
  return (
    <div data-testid="visit-page">
      <PageIntro
        label="Know Before You Go"
        titleLines={["Before", "you", "arrive."]}
        blurb="A few notes on how we bathe here."
      />

      {/* Know Before You Go list */}
      <section className="mx-auto max-w-[1600px] px-5 md:px-10" data-testid="know-before-list">
        <div className="border-t border-ink">
          {KNOW_BEFORE.map((k, i) => (
            <Reveal key={k.title} immediate delay={i * 0.06}>
              <div className="grid gap-4 border-b border-ink py-10 md:grid-cols-12 md:gap-10 md:py-14">
                <div className="flex items-baseline gap-6 md:col-span-5">
                  <span className="font-mono text-sm text-terracotta">0{i + 1}</span>
                  <h2 className="text-2xl font-medium tracking-tight md:text-4xl">{k.title}</h2>
                </div>
                <p className="text-lg font-normal leading-relaxed text-ink/75 md:col-span-7">{k.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Location & Hours */}
      <section className="mt-24 bg-terracotta text-espresso md:mt-36" data-testid="visit-location">
        <div className="mx-auto max-w-[1600px] px-5 py-24 md:px-10 md:py-32">
          <span className="text-xs uppercase tracking-[0.25em]">Location & Hours</span>
          <div className="mt-10 grid gap-14 md:grid-cols-12">
            <div className="md:col-span-6">
              <p className="text-5xl font-medium leading-[0.95] tracking-tight md:text-[4.5vw]">
                {LOCATION.address1}
              </p>
              <p className="mt-2 text-2xl font-normal tracking-tight md:text-3xl">{LOCATION.address2}</p>
              <a
                href={LOCATION.mapUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="visit-map-link"
                className="group mt-8 inline-flex items-center gap-2 text-sm uppercase tracking-[0.12em]"
              >
                <span className="border-b border-espresso pb-1">Open in maps</span>
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>

              <div className="mt-12 flex flex-wrap gap-x-10 gap-y-2 text-lg">
                <a href={`tel:${LOCATION.phone}`} className="border-b border-espresso pb-0.5">{LOCATION.phone}</a>
                <a href={`mailto:${LOCATION.email}`} className="border-b border-espresso pb-0.5">{LOCATION.email}</a>
              </div>
            </div>

            <div className="space-y-8 md:col-span-6">
              <div>
                <p className="mb-3 text-xs uppercase tracking-[0.2em] opacity-70">Hours</p>
                {LOCATION.hours.map((h) => (
                  <div key={h.days} className="flex justify-between border-b border-espresso/30 py-3 text-lg">
                    <span>{h.days}</span>
                    <span className="font-normal">{h.time}</span>
                  </div>
                ))}
              </div>
              <div>
                <p className="mb-3 text-xs uppercase tracking-[0.2em] opacity-70">Nearest Subway</p>
                <p className="text-lg">{LOCATION.subway}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
